import { render, staticRenderFns } from "./noticeSet.vue?vue&type=template&id=74d88fc2&scoped=true&"
import script from "./noticeSet.vue?vue&type=script&lang=js&"
export * from "./noticeSet.vue?vue&type=script&lang=js&"
import style0 from "./noticeSet.vue?vue&type=style&index=0&id=74d88fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d88fc2",
  null
  
)

export default component.exports